import { jsx as t } from "react/jsx-runtime";
import { useContext as a } from "react";
import { cn as f } from "./designsystem-ui-react47.js";
import { CardContext as r } from "./designsystem-ui-react62.js";
function p({ direction: o = "responsive", className: e, children: l }) {
  const n = a(r), s = {
    vertical: "tw-flex-col",
    horizontal: "tw-flex-row",
    responsive: "tw-flex-col @md:tw-flex-row"
  };
  return /* @__PURE__ */ t(r.Provider, { value: { ...n, direction: o }, children: /* @__PURE__ */ t("div", { className: f("tw-flex tw-h-full", s[o], e), children: l }) });
}
export {
  p as CardLayout
};
